module.exports = __webpack_public_path__ + "static/img/36_sing.54934ad8.jpg";